import {CartIconContainer, ItemCount, ShoppingIcon} from "./cart-icon.styles.js";
// import { ReactComponent as ShoppingIcon } from "../../asset/shopping-bag.svg";
import { useContext } from "react";
import { CartContext } from "../../contexts/cart.context";

const CartIcon = () => {

  const { isCartOpen, setIsCartOpen, cartCount}= useContext(CartContext)
  const toggleIsCartOpen=()=>{
    setIsCartOpen(!isCartOpen)

  }
  return (
    <CartIconContainer onClick={toggleIsCartOpen} >
      <ShoppingIcon className="shopping-icon"  />
      <ItemCount>{cartCount}</ItemCount>
    </CartIconContainer>
  );
};

export default CartIcon;
